import { apiGet } from './api'

export const getMoreForLessByEan = async (ean: number) => {
  const response = await apiGet(`/get-more-for-less/${ean}`)

  return response
}
